import React from 'react';

interface LoadingIconProps {
  fullScreen?: boolean;
  size?: number;
  color?: string;
}

/**
 * A loading icon component that can be customized with size and color.
 * @param fullScreen - Whether to take full screen height minus header
 * @param size - Size in Tailwind units (default: 8)
 * @param color - Color of the spinner (default: gray)
 */
const LoadingIcon: React.FC<LoadingIconProps> = ({
  fullScreen = false,
  size = 8,
  color = 'gray',
}) => (
  <div
    className="flex justify-center items-center"
    style={{ height: fullScreen && 'calc(100dvh - 60px)' }}
  >
    <div
      className={`animate-spin rounded-full w-${size} h-${size} border-2 border-${color}-600 border-t-transparent`}
    ></div>
  </div>
);

export default LoadingIcon;
